import { useDeviceFees } from '@/services/catalogue/useDeviceFees';

export const useDeviceFeeById = (id?: string, effectiveDate?: Date) => {
  const deviceFees = useDeviceFees(effectiveDate);
  return deviceFees.find(d => d.id === id);
};
